// import $ from 'jquery';
import Swiper from 'swiper/bundle';
// import 'swiper/css';
import Lenis from '@studio-freight/lenis'
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// import VanillaTilt from 'vanilla-tilt';
// import Vivus from 'vivus';
// gsap scrollTrigerr
gsap.registerPlugin(ScrollTrigger);
// const lenis = new Lenis({
//   duration: 0,
// })
// lenis.on('scroll', (e) => {})
// function raf(time) {
//   lenis.raf(time)
//   requestAnimationFrame(raf)
// }

const smartBreakPointMediaQuery = 920;
const isSmartPhone = () => {
  if (window.matchMedia && window.matchMedia('(max-device-width: 768px)').matches) {
    return true;
  } else {
    return false;
  }
};

// document.body.insertAdjacentHTML('beforeend',"<div id='gui' style='position: absolute;right: 30px;top: 30px;background: rgba(0, 0, 0, .5);padding: 20px;'></div>")
// document.querySelectorAll(".js-position-gui").forEach((guiTarget,i)=>{
//   const className = "js-gui-slide"+i;
//   const positon = guiTarget.getAttribute('data-position').split(',');
//   positon.forEach((pos)=>{
//     gui.insertAdjacentHTML('beforeend',pos+':<input type="range" data-type="'+pos+'" class="js-range '+className+'" min="-500" max="500" value="0" step="0.1" /><br>')
//   })
//   gui.insertAdjacentHTML('beforeend','<br>')
//   guiTarget.style.position ="absolute";
//   const inputRanges = document.querySelectorAll("."+className);
//   inputRanges.forEach((inputRange)=>{
//     inputRange.addEventListener('input', (e)=>{
//       const self = e.target;
//       if (self.getAttribute('data-type')==="left") {
//         guiTarget.style.left = (self.value*0.1)+'rem';
//       } else if(self.getAttribute('data-type')==="top") {
//         guiTarget.style.top = (self.value*0.1)+'rem';
//       } else if (self.getAttribute('data-type')==="right") {
//         guiTarget.style.right = (self.value*0.1)+'rem';
//       } else if(self.getAttribute('data-type')==="bottom") {
//         guiTarget.style.bottom = (self.value*0.1)+'rem';
//       }
//     })
//   })
// })


const topMvAnimation = () =>{
  const tl = gsap.timeline()
  const pathDuration = 2;
  // resets
  tl.set(".js-mv-path1", {'stroke-dasharray': '2980,2980'},)
  tl.set(".js-mv-path1", {'stroke-dashoffset': '0'},)
  
  tl.set(".js-mv-path2", {'stroke-dasharray': '2980,2980'},)
  tl.set(".js-mv-path2", {'stroke-dashoffset': '0'},)
  tl.set(".js-mv-path2", {'opacity': '0'},)

  tl.set(".js-mv-path3", {'stroke-dasharray': '2980,2980'},)
  tl.set(".js-mv-path3", {'stroke-dashoffset': '0'},)
  tl.set(".js-mv-path3", {'opacity': '0'},)
  // resets
  
  // animation1
  tl.fromTo(".js-mv-path1", 
    {'stroke-dashoffset': '2980'},
    {'stroke-dashoffset': '0', duration: pathDuration,stagger:0.2, ease: "power1.in",
  })
  
  tl.to(".js-mv-catch1", {'opacity': '1', y:0, duration: 1},)
  tl.to(".js-mv-catch1", {'opacity': '1', y:0, duration: 1},)
  tl.to(".js-mv-catch1", {'opacity': '0', duration: 1, delay:1.5},)
  tl.to(".js-mv-path1", {'stroke-dashoffset': '-2980', duration: pathDuration,stagger:0.2, ease: "power1.in",})
  tl.set(".js-mv-path1", {'opacity': '0'},)
  // animation1
  
  // animation2
  tl.set(".js-mv-path2", {'opacity': '1', delay: .15},)
  tl.fromTo(".js-mv-path2", 
    {'stroke-dashoffset': '2980'},
    {'stroke-dashoffset': '0', duration: pathDuration,stagger:0.2, ease: "power1.in"
  })
  tl.to(".js-mv-catch2", {'opacity': '1', y:0, duration: 1},)
  tl.to(".js-mv-catch2", {'opacity': '0', duration: 1, delay:1.5},)
  tl.to(".js-mv-path2", {'stroke-dashoffset': '-2980', duration: pathDuration,stagger:0.2, ease: "power1.in"})

  // animation3
  tl.set(".js-mv-path3", {'opacity': '1', delay: .15},)
  tl.fromTo(".js-mv-path3", 
    {'stroke-dashoffset': '2980'},
    {'stroke-dashoffset': '0', duration: pathDuration,stagger:0.2, ease: "power1.in"
  })
  tl.to(".js-mv-catch3", {'opacity': '1', y:0, duration: 1},)
  tl.to(".js-mv-catch3", {'opacity': '0', duration: 1, delay:1.5},)
  tl.to(".js-mv-path3", {'stroke-dashoffset': '-2980', duration: pathDuration,stagger:0.2, ease: "power1.in"})
  tl.repeat(-1)
  // animation2
};
topMvAnimation()


const topLogoAnimation = () => {
  let mm = gsap.matchMedia();
  const card = gsap.utils.toArray('.js-top-logo-img');
  const wrapper = document.querySelector('.js-top-logo');
  const footer = document.querySelector('.js-footer');
  if (card.length === 0 ) {
    return false;
  }
  const parallaxTl = gsap.timeline({
      scrollTrigger: {
        trigger: wrapper,
        start: "top center",
        // markers: true,
        end: wrapper.offsetHeight * 2,
        scrub: 1,
        duration: 4,
      },
  }); 
  parallaxTl.to(card[0], { x:"-8rem", y: "3rem", rotate: -27,  duration: 5,delay: .5,})
  parallaxTl.to(card[1], { x:"-5rem", y: "-4rem", rotate: -30, duration: 5,delay: .5,})
  parallaxTl.to(card[2], { x:"-2rem", y: "-6rem", rotate: -30, duration: 5,delay: .5,})
  parallaxTl.to(card[3], { x:"1rem", y: "-1rem", rotate: -6, duration: 5,delay: .5,})
  parallaxTl.to(card[4], { x:"3rem", y: "-6rem", rotate: 15, duration: 5,delay: .5,})
  parallaxTl.to(card[5], { x:"2rem", y: "2rem", rotate: -30, duration: 5,delay: .5,})
  parallaxTl.to(card[6], { x:"2rem", y: "-7rem", rotate: 17, duration: 5,delay: .5,})

  const parallaxTl2 = gsap.timeline({
      scrollTrigger: {
        trigger: footer,
        start: "top bottom",
        end: "bottom bottom",
        scrub: 1,
        duration: 3,
        // markers: true,
      },
  }); 
  parallaxTl2.to(card, { x: 0, y: 0, rotate: 0,  duration: 5, stagger: 1,delay: .5,})
};

const topAboutAnimation = () => {
  let mm = gsap.matchMedia();
  const logomark = document.querySelector('.js-logomark');
  // const parallaxTl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: document.querySelector(".top-about__inner"),
  //       start: "top center",
  //       markers: true,
  //       duration: 3,
  //     },
  // }); 
  gsap.to(logomark, { rotate: 360,  duration: .5,
    scrollTrigger: {
      trigger: document.querySelector(".js-logomark-wrapper"),
      start: "top center",
      end: "bottom-=800",
      scrub: 1,
      duration: 3,
    },
  })
};

topAboutAnimation()
topLogoAnimation()



const enteractives = gsap.utils.toArray('.js-enter-active');
if (enteractives) {
    enteractives.forEach((element, index) => {
        gsap.to(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top bottom',
                onEnter: () => element.classList.add('is-active'),
            }
        });
    });
}
const scrollInToggleClass = (targetEl, togglePointEl, toggleClass) => {

  if (togglePointEl) {
    const observer1 = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          targetEl.classList.remove(toggleClass);
        } else {
          targetEl.classList.add(toggleClass);
        }
      }
    });
    observer1.observe(togglePointEl);
  } else {
    if (targetEl) {
      targetEl.classList.add(toggleClass);
    }
  }
};

const header = document.querySelector(".js-header");
const hero = document.querySelector(".js-hero");
if (hero) {
  scrollInToggleClass(header,hero , "is-active")
} else {
  // header.classList.add("is-active")
}


// パララックスのターゲット取得
const target = document.querySelectorAll('.js-parallax');
// パララックスを行うエリア
const activeArea = document.querySelector('.js-parallax-area');
const drawer = document.querySelector('.js-drawer');
// ウィンドウの中心の取得
const xCenter = drawer.clientWidth / 2;
const yCenter = drawer.clientHeight / 2;
// パララックスで移動させる距離
const parallaxVal = 10; //中心からマウスの距離の10分１移動
// マウスがパララックスエリアに入った時のイベント
activeArea.addEventListener('mousemove', (e) => {
  if (!drawer.classList.contains("is-open")){
    return ;
  }
  // マウスの座標を取得して 中心からの距離取得、 そこからpararaxValで距離を調整
  const x = (xCenter - e.clientX) / parallaxVal;
  const y = (yCenter - e.clientY) / parallaxVal;
  // パララックスさせる要素にstyleの指定
  for (var i = 0; i < target.length; i++) {
    target[i].style.transform = `translate(${-x}px, ${-y}px)`;
  }
});

const spanWrapText = (target) => {
  const nodes = [...target.childNodes]; // ノードリストを配列にする
  let returnText = ''; // 最終的に返すテキスト

  for (const node of nodes) {
    if (node.nodeType == 3) {
      //テキストの場合
      const text = node.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
      const splitText = text.split(''); // 一文字ずつ分割
      for (const char of splitText) {
        returnText += `<span>${char}</span>`; // spanタグで挟んで連結
      }
    } else {
      //テキスト以外の場合
      //<br>などテキスト以外の要素をそのまま連結
      returnText += node.outerHTML;
    }
  }
  return returnText;
};
const spanWrapTextEls = document.querySelectorAll('.js-split-text')
if (spanWrapTextEls) {
  spanWrapTextEls.forEach((spanWrapTextEl) => spanWrapTextEl.innerHTML = spanWrapText(spanWrapTextEl))
}